export default {
  defaultSortField: 'name',
  defaultSortOrder: 'asc',
  isCheckable: false,
  isRowCheckable(row) {
    return !row.isDefault;
  },
  gutterOpts: [],
  toolBar: {
    searchPlaceHolder: 'Search Vendors',
     bulkActions: () => [
      {
        name: 'Delete Vendors',
        event: 'removeVendors',
        label: 'Delete',
        permissionModule: 'app&projects',
        alterDataKey: 'vendors',
      },
    ],
    buttons: [
      {
        event: 'openActivity',
        icon: 'icon-activityhistory',
        tooltip: 'Activity History',
        isLine: true,
      },
      {
        event: 'addNew',
        icon: 'icon-addnew',
        isLine: true,
        tooltip: 'Add Vendor',
        permissionModule: 'app&projects',
        alterDataKey: 'vendors',
      }, {
        event: 'excelImport',
        icon: 'icon-importexcel',
        tooltip: 'Import From Excel',
        isLine: true,
        permissionModule: 'app&projects',
        alterDataKey: 'vendors',
      },
    ],
  },
  fields: [
    {
      title: 'Vendor Name',
      name: 'name',
      width: '240px',
      id: 'name',
      sortField: 'name',
      prop: 'name',
      defaultVisible: true,
    },
    {
      title: 'Point of Contact',
      name: 'contactName',
      width: '112px',
      id: 'contactName',
      sortField: 'address.contactName',
      prop: 'address[0].contactName',
      defaultVisible: true,
    },
    {
      title: 'Email',
      name: 'email',
      width: '156px',
      id: 'email',
      prop: 'address[0].contactEmail',
      defaultVisible: true,
    },
    {
      title: 'Phone',
      name: 'phone',
      width: '112px',
      id: 'phone',
      sortField: 'address.phone',
      prop: 'address[0].phone',
      defaultVisible: true,
    },
    {
      title: 'Material Categories',
      name: 'category-count-icon',
      width: '112px',
      id: 'materialCategory',
      sortField: 'materialCategory',
      prop: 'category',
      defaultVisible: true,
    },
    {
      title: 'Sub Categories',
      name: 'category-count-icon',
      width: '112px',
      id: 'subCategory',
      prop: 'subCategory',
      defaultVisible: true,
    },
    {
      title: 'Address',
      name: 'address',
      width: '156px',
      id: 'address',
      prop: 'address[0]',
      defaultVisible: true,
      formatter(val) {
        if (!val) return '';
        const parts = [val.location, val.street, val.city, val.state, val.zip];
        return parts.filter((p) => p && String(p).trim()).join(', ');
      },
    },
    {
      title: 'Actions',
      name: 'table-field-actions',
      id: 'action',
      hideFromChooser: true,
      alwaysVisible: true,
      defaultVisible: true,
      width: '112px',
      permissionModule: 'app&projects',
      permissionKey: 'vendors',
      inputProps: {
        showEdit: false,
        groupButtons(rowData) {
          const buttons = [
            {
              icon: 'icon-edit',
              event: 'edit',
              tooltip: 'Edit Vendor',
              permissionModule: 'app&projects',
              alterDataKey: 'vendors',
            },
          ];
          if (!rowData.isDefault) {
            buttons.push({
              icon: 'icon-bin',
              event: 'vendor-archive',
              tooltip: 'Delete Vendor',
              permissionModule: 'app&projects',
              alterDataKey: 'vendors',
            });
          }
          return buttons;
        },
      },
    },
  ],
};